require('./bootstrap');

import Vue from 'vue';
import Vuex from 'vuex';
import 'es6-promise/auto'
import 'promise-polyfill/src/polyfill';

// Vue setup
// setting axios as the Vue $http prototype (needed from the typeahead component)
window.Vue = Vue;
Vue.prototype.$http = axios;
Vue.use(Vuex);

// vue global event emitter/listener
Vue.prototype.$event = new Vue();

import VueWaypoint from 'vue-waypoint'
Vue.use(VueWaypoint)

import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';


window.Swiper = Swiper;
window.SwiperNav =  Navigation;


window.isTrustpilotWidgetEnabled = false;
/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i);

files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

window.app = new Vue({
    el: '#app',
    store: new Vuex.Store(),
    data() {
        return {
            showCityOverlay: true
        }
    }
});

function toggleVisibility(element, targetId, toggleClass) {
    element.addEventListener('click', (event) => {
        document.getElementById(targetId).classList.toggle(toggleClass);
        event.target.classList.toggle(toggleClass);
    });
}

const readMore = document.querySelector('p[data-expand="read-more"]');
if (readMore) {
    toggleVisibility(readMore, 'extra-info', 'hidden');
}

const readLess = document.querySelector('p[data-expand="read-less"]');
if (readLess) {
    readLess.addEventListener('click', () => {
        const extraInfo = document.getElementById('extra-info');
        extraInfo.classList.toggle('hidden');
        document.getElementById('sector').scrollIntoView();
        if (readMore) {
            readMore.classList.remove('hidden');
        }
    });
}

window.getCurrentStep = function() {
    let url = new URL(window.location);
    return url.searchParams.get('step') || '';
}
